import AdvisorTeamLockedMember from "@modules/advisory-team/components/AdvisorTeamLockedMember";
import AdvisorTeamMemberInfo from "@modules/advisory-team/data/team-members.json";
import { FC } from "react";
import { HiOutlineLockClosed } from "react-icons/hi";
import { ADVISOR_SUPPORT_EMAIL } from "@modules/advisory-team/constants";
import { Button, Typography } from "@earned/core";

const AdvisorTeamLocked: FC = () => {
  return (
    <div className="p-10">
      <div className="relative w-full rounded-lg rounded-tl-xl border-2 border-primary bg-white lg:grid lg:grid-cols-3">
        <div className="absolute -ml-px -mt-px flex w-[121px] flex-row items-center justify-center gap-2 rounded-br-xl rounded-tl-xl bg-green-5 py-3.5">
          <HiOutlineLockClosed color="white" size={16} />
          <Typography variant="body" color="light">
            Locked
          </Typography>
        </div>
        <div className="mt-10 flex min-w-80 min-w-[320px] max-w-80 flex-row flex-col justify-around gap-4 p-10 lg:col-span-1 ">
          <div className="flex flex-col gap-4">
            <Typography variant="title-md" weight="medium" color="primary">
              Unlock the value of the Earned Team
            </Typography>
            <Typography variant="body-sm" color="secondary">
              Our advisors are analytically minded and experts in the unique
              career arc of physicians.
            </Typography>
          </div>
          <div>
            <Button href={`mailto:${ADVISOR_SUPPORT_EMAIL}`} variant="primary">
              Unlock the Earned Team
            </Button>
          </div>
        </div>
        <div className="my-[52px] lg:col-span-2 lg:pr-10">
          <div className="lg:grid lg:grid-cols-[repeat(auto-fill,_minmax(250px,_1fr))] lg:gap-3">
            <AdvisorTeamLockedMember
              teamMember={AdvisorTeamMemberInfo.Myhanh}
            />
            <AdvisorTeamLockedMember teamMember={AdvisorTeamMemberInfo.Bill} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvisorTeamLocked;
